import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Translate from "../translate/Translate";
import { Button,Divider, Tag,Typography } from 'antd';
import RImage from '../static/resultDream-settings.png';
import IImage from '../static/resultDream-magnifier.png';
import AImage from '../static/resultDream-paint-palette.png';
import SImage from '../static/resultDream-conversation.png';
import EImage from '../static/resultDream-suitcase.png';
import CImage from '../static/resultDream-notes.png';
import field1 from '../static/resultDream-1.png';
import field2 from '../static/resultDream-2.png';
import field3 from '../static/resultDream-3.png';

import {
    RightOutlined, LeftOutlined
} from '@ant-design/icons';

import { resultDreamSearch, resultDreamDetailGet, resultSuggestDetailGet } from "../../modules/result";

class ResultJobModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // visible: true,
            resultJobSearchData: [],
            resultData: [],
            selectedJob: null,
            resultJobDetail: {},
        }
    }

    componentDidMount() {
        // console.log("yo");
        console.log(this.state.resultJobSearchData)
        if (this.props.resultData) {
            this.setState({ resultData: this.props.resultData }, () => this.renderJobSection())
        }

    }

    renderJobSection() {
        //*********************TEST"廚師"********************** */
        console.log(this.state.resultData,this.state.resultData.ranking)
        resultSuggestDetailGet(this.state.resultData.ranking).then(
            (returnData) => {
                console.log(returnData)
                this.setState({ resultJobSearchData: returnData })
                if (returnData.total > 0) {
                    for (const value of returnData.results) {
                        // (value) => {
                        resultDreamDetailGet(value["_id"]).then(
                            (detail) => {
                                this.setState({
                                    resultJobDetail: {
                                        ...this.state.resultJobDetail,
                                        [value["_id"]]: detail
                                    }
                                });
                            }
                        )
                        // console.log(this.state.resultJobDetail)
                        // }
                    }

                }
            }
        ).catch(
            (error) => {
                // console.log(error);
            }
        )
    }

    // componentDidUpdate(prevProps, prevState) {
    //     Object.entries(this.props).forEach(([key, val]) =>
    //         prevProps[key] !== val && console.log(`Prop '${key}' changed${val}`)
    //     );
    //     if (this.state) {
    //         Object.entries(this.state).forEach(([key, val]) => {
    //             prevState[key] !== val && console.log(`State '${key}' changed${val}`)
    //             // if(key=="selectedJob"){
    //             //     this.props.resultJobDetailGet(val)
    //             // }
    //         }

    //         );
    //     }
    // }

    checkDream(target) {
        this.setState({ selectedJob: target })
    }

    getDetail() {
        this.props.resultJobDetailGet(this.state.selectedJob)
    }

    render() {
        const image = { R: RImage, I: IImage, A: AImage, S: SImage, E: EImage, C: CImage };
        const { resultJobDetail, selectedJob, resultData, resultJobSearchData } = this.state;
        const hashtagcolour = ["magenta", "red", "volcano", "orange", "gold"]

        return (
            <div >
                {
                    (!selectedJob) ?
                        (resultJobSearchData) ?
                            (resultJobSearchData.total > 0) ?
                                <div className="resultDreamSearchRedirectFieldContainer">
                                    {
                                        resultJobSearchData.results.map(
                                            (jobData) => {
                                                // console.log(jobData)
                                                return (
                                                    <Button
                                                        onClick={this.checkDream.bind(this, jobData["_id"])}
                                                        type="primary" className={"resultDreamBtn  resultDreamBtnColor"} key={jobData._id}>
                                                        {jobData.name.map(
                                                            value => {
                                                                // console.log(value)
                                                                if (value.lang == this.props.language)
                                                                    return (
                                                                        value.name
                                                                    )
                                                            }
                                                        )
                                                        }
                                                        <RightOutlined className="resultBtnMore" />
                                                    </Button>
                                                )
                                            }
                                        )
                                    }
                                    <p></p>
                                </div>
                                : <Translate id="resultDream.notfound" />
                            :<Translate id="resultDream.notfound" />
                            :
                            // -------------------------------Detail--------------------------------
                            <div>
                                <Button type="link" onClick={() => this.setState({ selectedJob: null })}><LeftOutlined /></Button>
                                <div className="resultDreamDetailContainer">
                                    <div className="resultDreamDetailField resultJobDetailTitle">
                                        <span><Typography.Title level={5}>{resultJobDetail[selectedJob]["name"][0]["name"]}</Typography.Title></span>
                                        <span className={"resultDreamColor" + resultJobDetail[selectedJob]["code"][0]}><img src={image[resultJobDetail[selectedJob]["code"][0]]} className="resultDreamImg"></img><Translate id={"type." + resultJobDetail[selectedJob]["code"][0]}></Translate></span>
                                    </div>
                                    <div className="resultDreamDetailField popuptextColor">
                                        <span><Translate id="resultDream.Intro"></Translate>:
                                    {resultJobDetail[selectedJob]["career"].map(
                                            (value) => {
                                                // console.log(value)
                                                if (value.lang == this.props.language)
                                                    return (value.description)
                                            })
                                            }
                                        </span>
                                        <span><Translate id="resultDream.SDS"></Translate>:&nbsp;{resultJobDetail[selectedJob]["code"]}</span>
                                    </div>

                                    <div className="resultDreamDetailDescriptionField">
                                        <div className="resultDreamDetailDescription">
                                            <div ><img src={field1} className="resultDreamTitleImg"></img><Translate id="resultDream.detail.title1"></Translate></div>
                                            {
                                                resultJobDetail[selectedJob]["description"].map(
                                                    (value) => {
                                                        // console.log(value)
                                                        if (value.lang == this.props.language) {
                                                            return value.descriptions.map(
                                                                (descrip, index) => { return (<div key={index} className="popuptextColor resultJobDetail">{index + 1}. {descrip}</div>) }
                                                            )
                                                        }
                                                    }
                                                )
                                            }
                                        </div>
                                        <Divider type="vertical" />
                                        <div className="resultDreamDetailDescription">
                                            <div ><img src={field2} className="resultDreamTitleImg"></img><Translate id="resultDream.detail.title2"></Translate></div>
                                            {
                                                resultJobDetail[selectedJob]["character"].map(
                                                    (value) => {
                                                        // console.log(value)
                                                        if (value.lang == this.props.language) {
                                                            return value.characters.map(
                                                                (descrip, index) => { return (<div  key={index} className="popuptextColor resultJobDetail">{index + 1}. {descrip}</div>) }
                                                            )
                                                        }
                                                    }
                                                )
                                            }
                                        </div>
                                        <Divider type="vertical" />
                                        <div className="resultDreamDetailDescription">
                                            <div ><img src={field3} className="resultDreamTitleImg"></img><Translate id="resultDream.detail.title3"></Translate></div>
                                            {
                                                resultJobDetail[selectedJob]["requirement"].map(
                                                    (value) => {
                                                        // console.log(value)
                                                        if (value.lang == this.props.language) {
                                                            return value.requirements.map(
                                                                (descrip, index) => { return (<div  key={index} className="popuptextColor resultJobDetail">{index + 1}. {descrip}</div>) }
                                                            )
                                                        }
                                                    }
                                                )
                                            }
                                        </div>
                                    </div>

                                    <div style={{ padding: "5px 0" }}>
                                        <Translate id="resultDream.detail.title4"></Translate>:&nbsp;
                                    {
                                            resultJobDetail[selectedJob]["hashTag"].map(
                                                (value) => {
                                                    // console.log(value)
                                                    if (value.lang == this.props.language) {
                                                        return value.hashTags.map(
                                                            (hashTag, index) => { return (<Tag  key={index} color={hashtagcolour[index]}># {hashTag}</Tag>) }
                                                        )
                                                    }
                                                }
                                            )
                                        }
                                    </div>
                                </div>
                            </div>
            }
            </div>
        )
    }
}

const mapStateToProps = state => ({
    language: state.mainpage.language,
    resultData: state.result.resultData,
    // resultJobSearchData: state.result.resultJobSearchData,
    // resultJobDetail: state.result.resultJobDetail,
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {

        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ResultJobModal);
